module.exports = __webpack_public_path__ + "media/images/favicon/favicon@512h-50f2c94d59073517e9f853cbf403229a.png";